import React from 'react';
import { FaFacebook, FaInstagram, FaWhatsapp, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer" id="contact">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">DAIRYZAR</h3>
            <p className="footer-description">
              Your trusted source for 100% pure and natural products. We bring the best of nature to your doorstep.
            </p>
            <div className="social-links">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-link">
                <FaFacebook />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-link">
                <FaInstagram />
              </a>
              <a href="https://wa.me/923126108161" target="_blank" rel="noopener noreferrer" className="social-link whatsapp">
                <FaWhatsapp />
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><a href="#home">Home</a></li>
              <li><a href="#products">Products</a></li>
              <li><a href="#features">Why Us</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Our Products</h4>
            <ul className="footer-links">
              <li><a href="#products">Desi Ghee</a></li>
              <li><a href="#products">Wild Honey</a></li>
              <li><a href="#products">Shilajit</a></li>
              <li><a href="#products">Natural Oils</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Contact Us</h4>
            <div className="contact-info">
              <div className="contact-item">
                <FaPhone />
                <a href="tel:+923126108161">0312 6108161</a>
              </div>
              <div className="contact-item">
                <FaEnvelope />
                <a href="mailto:order@dairyzar.com">order@dairyzar.com</a>
              </div>
              <div className="contact-item">
                <FaMapMarkerAlt />
                <span>Karachi, Pakistan</span>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2024 Dairyzar. All rights reserved. | Developed with love for pure natural products</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;